import { ApolloClient, InMemoryCache } from "@apollo/client";

import {
  gatewaySvcUri,
  isDev,
  nextCFClientId,
  nextCFClientSecret,
} from "@app/constants";

const apiGatewayClient = (
  accessToken?: string | null,
  refreshToken?: string | null
) => {
  const headers: Record<string, string> = {
    ...(isDev
      ? {
          "CF-Access-Client-Id": nextCFClientId,
          "CF-Access-Client-Secret": nextCFClientSecret,
        }
      : {}),
  };

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  if (refreshToken) {
    headers["x-keycloak-refresh-token"] = refreshToken;
  }

  return new ApolloClient({
    uri: gatewaySvcUri,
    cache: new InMemoryCache(),
    headers,
  });
};

export default apiGatewayClient;
